export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":{"en-AU":["en-GB"],"en-IE":["en-GB"],"en-NZ":["en-GB"],"es-ES":["es-419"],"default":["en"]},"silentTranslationWarn":true,"formatFallbackMessages":true},
  vueI18nLoader: false,
  locales: [{"code":"en","iso":"en-US","file":"en-US.json","name":"English"},{"code":"en-GB","iso":"en-GB","file":"en-GB.json","name":"English (British)"},{"code":"fr","iso":"fr-FR","file":"fr-FR.json","name":"French - Français"},{"code":"de","iso":"de-DE","file":"de-DE.json","name":"German - Deutsch"},{"code":"zh","iso":"zh-Hans","file":"zh-Hans.json","name":"Simplified Chinese - 中文(简体)"},{"code":"zh-Hant","iso":"zh-Hant","file":"zh-Hant.json","name":"Traditional Chinese - 中文(香港)"},{"code":"es-ES","iso":"es-ES","file":"es-ES.json","name":"Spanish - Español (España)"},{"code":"it","iso":"it-IT","file":"it-IT.json","name":"Italian - Italia"},{"code":"pt","iso":"pt-BR","file":"pt-BR.json","name":"Portuguese - Português"},{"code":"ko","iso":"ko-KR","file":"ko-KR.json","name":"Korean - 한국어"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "~~/locale/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":315360000000,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"locale","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","iso":"en-US","file":"en-US.json","name":"English"},{"code":"en-GB","iso":"en-GB","file":"en-GB.json","name":"English (British)"},{"code":"fr","iso":"fr-FR","file":"fr-FR.json","name":"French - Français"},{"code":"de","iso":"de-DE","file":"de-DE.json","name":"German - Deutsch"},{"code":"zh","iso":"zh-Hans","file":"zh-Hans.json","name":"Simplified Chinese - 中文(简体)"},{"code":"zh-Hant","iso":"zh-Hant","file":"zh-Hant.json","name":"Traditional Chinese - 中文(香港)"},{"code":"es-ES","iso":"es-ES","file":"es-ES.json","name":"Spanish - Español (España)"},{"code":"it","iso":"it-IT","file":"it-IT.json","name":"Italian - Italia"},{"code":"pt","iso":"pt-BR","file":"pt-BR.json","name":"Portuguese - Português"},{"code":"ko","iso":"ko-KR","file":"ko-KR.json","name":"Korean - 한국어"}],
  localeCodes: ["en","en-GB","fr","de","zh","zh-Hant","es-ES","it","pt","ko"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "-",
  5: "U",
  6: "S",
  7: ".",
  8: "j",
  9: "s",
  10: "o",
  11: "n",
  12: "\"",
  13: ":",
  14: "\"",
  15: ".",
  16: ".",
  17: "/",
  18: "l",
  19: "o",
  20: "c",
  21: "a",
  22: "l",
  23: "e",
  24: "/",
  25: "e",
  26: "n",
  27: "-",
  28: "U",
  29: "S",
  30: ".",
  31: "j",
  32: "s",
  33: "o",
  34: "n",
  35: "\"",
  36: ",",
  37: "\"",
  38: "e",
  39: "n",
  40: "-",
  41: "G",
  42: "B",
  43: ".",
  44: "j",
  45: "s",
  46: "o",
  47: "n",
  48: "\"",
  49: ":",
  50: "\"",
  51: ".",
  52: ".",
  53: "/",
  54: "l",
  55: "o",
  56: "c",
  57: "a",
  58: "l",
  59: "e",
  60: "/",
  61: "e",
  62: "n",
  63: "-",
  64: "G",
  65: "B",
  66: ".",
  67: "j",
  68: "s",
  69: "o",
  70: "n",
  71: "\"",
  72: ",",
  73: "\"",
  74: "f",
  75: "r",
  76: "-",
  77: "F",
  78: "R",
  79: ".",
  80: "j",
  81: "s",
  82: "o",
  83: "n",
  84: "\"",
  85: ":",
  86: "\"",
  87: ".",
  88: ".",
  89: "/",
  90: "l",
  91: "o",
  92: "c",
  93: "a",
  94: "l",
  95: "e",
  96: "/",
  97: "f",
  98: "r",
  99: "-",
  100: "F",
  101: "R",
  102: ".",
  103: "j",
  104: "s",
  105: "o",
  106: "n",
  107: "\"",
  108: ",",
  109: "\"",
  110: "d",
  111: "e",
  112: "-",
  113: "D",
  114: "E",
  115: ".",
  116: "j",
  117: "s",
  118: "o",
  119: "n",
  120: "\"",
  121: ":",
  122: "\"",
  123: ".",
  124: ".",
  125: "/",
  126: "l",
  127: "o",
  128: "c",
  129: "a",
  130: "l",
  131: "e",
  132: "/",
  133: "d",
  134: "e",
  135: "-",
  136: "D",
  137: "E",
  138: ".",
  139: "j",
  140: "s",
  141: "o",
  142: "n",
  143: "\"",
  144: ",",
  145: "\"",
  146: "z",
  147: "h",
  148: "-",
  149: "H",
  150: "a",
  151: "n",
  152: "s",
  153: ".",
  154: "j",
  155: "s",
  156: "o",
  157: "n",
  158: "\"",
  159: ":",
  160: "\"",
  161: ".",
  162: ".",
  163: "/",
  164: "l",
  165: "o",
  166: "c",
  167: "a",
  168: "l",
  169: "e",
  170: "/",
  171: "z",
  172: "h",
  173: "-",
  174: "H",
  175: "a",
  176: "n",
  177: "s",
  178: ".",
  179: "j",
  180: "s",
  181: "o",
  182: "n",
  183: "\"",
  184: ",",
  185: "\"",
  186: "z",
  187: "h",
  188: "-",
  189: "H",
  190: "a",
  191: "n",
  192: "t",
  193: ".",
  194: "j",
  195: "s",
  196: "o",
  197: "n",
  198: "\"",
  199: ":",
  200: "\"",
  201: ".",
  202: ".",
  203: "/",
  204: "l",
  205: "o",
  206: "c",
  207: "a",
  208: "l",
  209: "e",
  210: "/",
  211: "z",
  212: "h",
  213: "-",
  214: "H",
  215: "a",
  216: "n",
  217: "t",
  218: ".",
  219: "j",
  220: "s",
  221: "o",
  222: "n",
  223: "\"",
  224: ",",
  225: "\"",
  226: "e",
  227: "s",
  228: "-",
  229: "E",
  230: "S",
  231: ".",
  232: "j",
  233: "s",
  234: "o",
  235: "n",
  236: "\"",
  237: ":",
  238: "\"",
  239: ".",
  240: ".",
  241: "/",
  242: "l",
  243: "o",
  244: "c",
  245: "a",
  246: "l",
  247: "e",
  248: "/",
  249: "e",
  250: "s",
  251: "-",
  252: "E",
  253: "S",
  254: ".",
  255: "j",
  256: "s",
  257: "o",
  258: "n",
  259: "\"",
  260: ",",
  261: "\"",
  262: "i",
  263: "t",
  264: "-",
  265: "I",
  266: "T",
  267: ".",
  268: "j",
  269: "s",
  270: "o",
  271: "n",
  272: "\"",
  273: ":",
  274: "\"",
  275: ".",
  276: ".",
  277: "/",
  278: "l",
  279: "o",
  280: "c",
  281: "a",
  282: "l",
  283: "e",
  284: "/",
  285: "i",
  286: "t",
  287: "-",
  288: "I",
  289: "T",
  290: ".",
  291: "j",
  292: "s",
  293: "o",
  294: "n",
  295: "\"",
  296: ",",
  297: "\"",
  298: "p",
  299: "t",
  300: "-",
  301: "B",
  302: "R",
  303: ".",
  304: "j",
  305: "s",
  306: "o",
  307: "n",
  308: "\"",
  309: ":",
  310: "\"",
  311: ".",
  312: ".",
  313: "/",
  314: "l",
  315: "o",
  316: "c",
  317: "a",
  318: "l",
  319: "e",
  320: "/",
  321: "p",
  322: "t",
  323: "-",
  324: "B",
  325: "R",
  326: ".",
  327: "j",
  328: "s",
  329: "o",
  330: "n",
  331: "\"",
  332: ",",
  333: "\"",
  334: "k",
  335: "o",
  336: "-",
  337: "K",
  338: "R",
  339: ".",
  340: "j",
  341: "s",
  342: "o",
  343: "n",
  344: "\"",
  345: ":",
  346: "\"",
  347: ".",
  348: ".",
  349: "/",
  350: "l",
  351: "o",
  352: "c",
  353: "a",
  354: "l",
  355: "e",
  356: "/",
  357: "k",
  358: "o",
  359: "-",
  360: "K",
  361: "R",
  362: ".",
  363: "j",
  364: "s",
  365: "o",
  366: "n",
  367: "\"",
  368: "}",
}

export const localeMessages = {
  'en-US.json': () => import('../../locale/en-US.json' /* webpackChunkName: "lang-en-US.json" */),
  'en-GB.json': () => import('../../locale/en-GB.json' /* webpackChunkName: "lang-en-GB.json" */),
  'fr-FR.json': () => import('../../locale/fr-FR.json' /* webpackChunkName: "lang-fr-FR.json" */),
  'de-DE.json': () => import('../../locale/de-DE.json' /* webpackChunkName: "lang-de-DE.json" */),
  'zh-Hans.json': () => import('../../locale/zh-Hans.json' /* webpackChunkName: "lang-zh-Hans.json" */),
  'zh-Hant.json': () => import('../../locale/zh-Hant.json' /* webpackChunkName: "lang-zh-Hant.json" */),
  'es-ES.json': () => import('../../locale/es-ES.json' /* webpackChunkName: "lang-es-ES.json" */),
  'it-IT.json': () => import('../../locale/it-IT.json' /* webpackChunkName: "lang-it-IT.json" */),
  'pt-BR.json': () => import('../../locale/pt-BR.json' /* webpackChunkName: "lang-pt-BR.json" */),
  'ko-KR.json': () => import('../../locale/ko-KR.json' /* webpackChunkName: "lang-ko-KR.json" */),
}
